import { render } from "./AppProfessionSelect.vue?vue&type=template&id=047acd1e"
import script from "./AppProfessionSelect.vue?vue&type=script&lang=ts"
export * from "./AppProfessionSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script